export function getEnv() {
  // ip或者localhost
  if (
    /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(location.host) ||
    location.host.includes('localhost')
  ) {
    return 'fat';
  } else if (location.host.includes('dev')) {
    return 'development';
  } else if (location.host.includes('fat')) {
    return 'fat';
  }
  return 'production';
}

export function env() {
  const obj = {
    local: {
      ipoddy: 'https://chore-dev.ipoddy.cn',
      aiad: 'https://chore-dev.lingvisions.com',
    },
    development: {
      ipoddy: 'https://chore-dev.ipoddy.cn',
      aiad: 'https://chore-dev.lingvisions.com',
    },
    fat: {
      ipoddy: 'https://chore-fat.ipoddy.cn',
      aiad: 'https://chore-fat.lingvisions.com',
    },
    production: {
      ipoddy: 'https://www.ipoddy.cn',
      aiad: 'https://www.lingvisions.com',
    },
  };
  return obj[getEnv()];
}
